import { render, staticRenderFns } from "./agv-key-features.vue?vue&type=template&id=4d5b0196&scoped=true&lang=pug&"
import script from "./agv-key-features.vue?vue&type=script&lang=js&"
export * from "./agv-key-features.vue?vue&type=script&lang=js&"
import style0 from "./agv-key-features.vue?vue&type=style&index=0&id=4d5b0196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b0196",
  null
  
)

export default component.exports